import React from 'react';
import { Link } from 'react-router-dom';

/**
 * What's Next Widget - Clean & Minimal
 * Shows users their immediate action items
 */
const WhatsNextWidget = ({ userType = 'influencer', actionItems = [] }) => {
  const items = actionItems.length > 0 ? actionItems : [];

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return {
          bg: 'bg-red-50',
          border: 'border-red-200',
          text: 'text-red-800',
          badge: 'bg-red-500',
          icon: 'text-red-500'
        };
      case 'medium':
        return {
          bg: 'bg-yellow-50',
          border: 'border-yellow-200',
          text: 'text-yellow-800',
          badge: 'bg-yellow-500',
          icon: 'text-yellow-500'
        };
      case 'normal':
        return {
          bg: 'bg-blue-50',
          border: 'border-blue-200',
          text: 'text-blue-800',
          badge: 'bg-blue-500',
          icon: 'text-blue-500'
        };
      default:
        return {
          bg: 'bg-gray-50',
          border: 'border-gray-200',
          text: 'text-gray-800',
          badge: 'bg-gray-500',
          icon: 'text-gray-500'
        };
    }
  };

  const getCategoryLabel = (category) => {
    const labels = {
      urgent: 'Urgent',
      action_required: 'Action Required',
      waiting: 'Waiting',
      reminder: 'Reminder'
    };
    return labels[category] || category;
  };

  if (items.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">
            What's Next
          </h3>
        </div>
        <div className="text-center py-6">
          <p className="text-sm text-gray-600">
            No pending action items
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">
            What's Next
          </h3>
          <span className="text-sm text-gray-500">
            {items.length} {items.length === 1 ? 'item' : 'items'}
          </span>
        </div>
      </div>

      {/* Action Items */}
      <div className="divide-y divide-gray-200">
        {items.map((item) => {
          
          return (
            <div
              key={item.id}
              className="p-4 hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-start justify-between">
                {/* Left side - content */}
                <div className="flex-1">
                  {/* Title */}
                  <h4 className="font-medium text-gray-900 mb-1">
                    {item.title}
                  </h4>

                  {/* Description */}
                  <p className="text-sm text-gray-600 mb-2">
                    {item.description}
                  </p>

                  {/* Due date */}
                  {item.dueDate && (
                    <p className="text-xs text-gray-500 mb-2">
                      Due: {item.dueDate}
                    </p>
                  )}

                  {/* Action button */}
                  <Link
                    to={item.link}
                    className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-800"
                  >
                    {item.action}
                    <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Footer */}
      {items.length > 3 && (
        <div className="px-6 py-3 border-t border-gray-200">
          <Link
            to={userType === 'influencer' ? '/influencer/campaigns' : '/brand/campaigns'}
            className="text-sm font-medium text-blue-600 hover:text-blue-800 flex items-center justify-center"
          >
            View All Campaigns
            <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      )}
    </div>
  );
};

export default WhatsNextWidget;
